import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Cartao } from '../../../../models/empresa/cartao';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { LoadingService } from '../../../../util/loader.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { ControleDeAcessoService } from '../controle-acesso.service';
import { FiltroControleDeAcesso } from '../../../../models/controle-acesso/filtroControleDeAcesso';
import { ControDeAcesso, PaginaAcesso } from '../../../../models/controle-acesso/ControleDeAcesso';
const swal = require('sweetalert');

@Component({
  selector: 'app-modal-controle-de-acesso',
  templateUrl: './modal-controle-de-acesso.component.html',
  styleUrls: ['./modal-controle-de-acesso.component.scss']
})
export class ModalControleDeAcessoComponent implements OnInit {
  valForm: FormGroup;
  public onClose: Subject<any>;
  public codigo: number;
  public record: ControDeAcesso;
  public emailUsuario: string;
  public grupos: Array<any>;
  public devices: Array<any>;
  public paginas: Array<PaginaAcesso>;
  public id_pagina: number;



  constructor(fb: FormBuilder, private _bsModalRef: BsModalRef, public loader: LoadingService, private service: ControleDeAcessoService, private route: ActivatedRoute, private _localeService: BsLocaleService) {
    this.record = new ControDeAcesso();
    this.valForm = fb.group({
      //'cartaoDescricao': [null,Validators.compose([ Validators.required, Validators.maxLength(150)])],
      // 'cartaoNome': [null, Validators.required],
      //'cartaoQuantidadeDePontos': [null, Validators.required],
      //'cartaoPossuiValidade': [null, Validators.required],
      'grupos': [null, Validators.required],
      'paginas': [null, null],
      'devices': [null, null],
      'emailUsuario': [null, null]
    });
    this.listarGrupo();

    this.listarDevices();

  }

  ngOnInit() {
    this.onClose = new Subject();
    this.valForm.controls['paginas'].disable();
    if (this.record.id_grupo_usuario != null) {
      this.valForm.controls['grupos'].disable();
      this.valForm.controls['emailUsuario'].disable();
    } else {
      this.valForm.controls['grupos'].enable();
      this.valForm.controls['emailUsuario'].enable();
    }
  }
  dispositivoSelecionado(valor) {
    this.valForm.controls['paginas'].enable();
    this.listarPagina(valor);
  }
  submitForm($ev, value: any, buttonType: string) {
    $ev.preventDefault();
    for (const c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      if (this.record.acessos.length == 0) {
        swal('Atenção', 'Selecione algum recurso para da permissão.', 'warning');
      } else if (this.record.id_usuarios == null) {
        swal('Atenção', 'Selecione um usuário para ser seu colaborador.', 'warning');
      } else {
        this.loader.show("body");
        if (this.record.id_grupo_usuario == null) {

          this.service.cadastrarPermissao(this.record)
            .subscribe((itens) => {
              this.loader.hide("body");
              if (itens == true) {
                swal('Atenção', 'Cadastro  realizado com sucesso.', 'success');
                this.record.id_usuarios = null;
                this.record.url = null;
                this.record.nome = null;
                this.record.email = null;
                this.record.existeUsuario = false;
                this.record.acessos = Array<PaginaAcesso>();
                this.onOk();
              }
            });
        } else {
          this.service.atualizarPermissao(this.record)
            .subscribe((itens) => {
              this.loader.hide("body");
              if (itens == true) {
                swal('Atenção', 'Atualização   realizada com sucesso.', 'success');
                this.record.id_usuarios = null;
                this.record.url = null;
                this.record.nome = null;
                this.record.email = null;
                this.record.existeUsuario = false;
                this.record.acessos = Array<PaginaAcesso>();
                this.onOk();
              }
            });
        }
      }
    }
  }
  listarGrupo() {
    this.loader.show("body");
    this.service.obterGrupos()
      .subscribe((itens) => {
        this.loader.hide("body");
        this.grupos = itens;
      });
  }

  listarPagina(valor) {
    this.loader.show("body");

    this.service.obterPaginas(valor)
      .subscribe((itens) => {
        this.loader.hide("body");
        this.paginas = itens;
      });
  }
  listarDevices() {
    this.loader.show("body");
    this.service.obterDevices()
      .subscribe((itens) => {
        this.loader.hide("body");
        this.devices = itens;
      });
  }
  buscarUsuario() {

    if (this.emailUsuario == null) {
      swal('Atenção', 'Digite o e-mail do usuário.', 'warning');
    } else {
      this.record.id_usuarios = null;
      this.record.url = null;
      this.record.nome = null;
      this.record.email = null;
      this.record.existeUsuario = false;

      this.loader.show("body");
      this.service.obterUsuario(this.emailUsuario)
        .subscribe((itens) => {
          this.loader.hide("body");
          if (itens != null && itens.hasOwnProperty('id_usuarios')) {
            this.record.id_usuarios = itens.id_usuarios;
            this.record.url = itens.url;
            this.record.nome = itens.nome;
            this.record.email = itens.email;
            this.record.existeUsuario = true;
            this.emailUsuario = null;
          } else {
            this.record.id_usuarios = null;
            this.record.url = null;
            this.record.nome = null;
            this.record.email = null;
            this.record.existeUsuario = false;
            swal('Atenção', 'Usuário não encontrado.', 'warning');
          }
        });
    }
  }


  addAcao() {
    if (this.id_pagina != null) {
      const item = this.paginas.find(t => t.id_pagina === this.id_pagina);
      const itemExist = this.record.acessos.find(t => t.id_pagina === this.id_pagina);
      if (itemExist) {
        swal('Atenção', 'Permissão já inclusa.', 'warning');
      } else {
        this.record.acessos.push(item);
        this.id_pagina = null;
      }
    }
  }

  remover(record) {
    this.removerItemUtil(this.record.acessos, record);
  }


  removerItemUtil(arr, item) {
    for (let i = arr.length; i--;) {
      if (arr[i].id_pagina === item.id_pagina) {
        arr.splice(i, 1);

      }
    }
  }
  public onCancel(): void {
    const output = {
      reload: false
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

  public onOk(): void {
    const output = {
      reload: true
    };
    this.onClose.next(output);
    this._bsModalRef.hide();
  }

}
